"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGatewayConfigLike = exports.GatewayConfig = exports.GatewayConfigClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelCommon_1 = require("../ModelCommon");
exports.GatewayConfigClassName = 'GatewayConfig';
class GatewayConfig extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.GatewayConfigClassName)
            throw new Error(`Tried to create a ${exports.GatewayConfigClassName} from a ${ob.type} object!`);
        super(exports.GatewayConfigClassName, { ...ob });
        this.type = ob.type ?? exports.GatewayConfigClassName;
        this.AWS_LPWAN = ob.AWS_LPWAN;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            crt: { type: 'String', editable: false, label: 'Gateway Cert', valueFn: () => this.AWS_LPWAN?.cupsInfo.crt },
            key: { type: 'String', editable: false, label: 'Key', valueFn: () => this.AWS_LPWAN?.cupsInfo.key },
            trust: { type: 'String', editable: false, label: 'Trust Cert', valueFn: () => this.AWS_LPWAN?.cupsInfo.key },
            uri: { type: 'String', editable: false, label: 'LNS URI', valueFn: () => this.AWS_LPWAN?.cupsInfo.uri },
        };
    }
}
exports.GatewayConfig = GatewayConfig;
GatewayConfig.getGatewayConfigKeys = (gateway) => (0, iotv_v3_types_1.getZombieInstanceFromPrimaryKey)(`${exports.GatewayConfigClassName}:${gateway.id}`, { pk: gateway.sk });
const isGatewayConfigLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.GatewayConfigClassName;
};
exports.isGatewayConfigLike = isGatewayConfigLike;
